import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8010/api';

const client = axios.create({ baseURL: `${BASE_URL}/` });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('helpdesk_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('helpdesk_access_token');
      localStorage.removeItem('helpdesk_employee');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default client;
